<script>
  export default {
    name: 'kayak',
    props: ['slug'],
    data () {
      return {
        item: null,
        pricingTableFields: [
          {
            key: 'name',
            label: 'Prezzi',
            class: 'single-table-row-cell'
          },
          {
            key: 'value',
            label: '',
            class: 'align-right single-table-row-cell'
          },
        ],
        pricingTableItems: [],
        technicalDataTableFields: [
          {
            key: 'name',
            label: 'Dati tecnici',
            class: 'single-table-row-cell'
          },
          {
            key: 'value',
            label: '',
            class: 'align-right single-table-row-cell'
          },
        ],
        technicalDataTableItems: [],
        characteristicsTableFields: [
          {
            key: 'name',
            label: 'Caratteristiche',
            class: 'single-table-row-cell'
          },
          {
            key: 'value',
            label: '',
            class: 'align-right single-table-row-cell'
          },
        ],
        characteristicsTableItems: [],
      }
    },
    computed: {
      imagePath () {
        return require("@/assets/images/uploads/kayaks/" + this.item.slug + ".png")
      },
    },
    methods: {
      getKayakBySlug() {
        var item = null;
        try {
          item = require('@/assets/data/json/kayaks/detail/' + this.slug + '.json');
        } catch (e) {}
        if(item != null) {
          this.mapKayakData(item)
          this.item = item
        }
      },
      mapKayakData(item) {
        this.pricingTableItems = item.materials.map((item) => {
          var obj = {
            name: item.name,
            value: item.pricing + " " + item.currencySymbol
          }
          return obj
        });
        this.technicalDataTableItems = item.technicalData.map((item) => {
          var obj = {
            name: item.name,
            value: item.value != null ? item.value + " " + item.unit : '-'
          }
          return obj
        });
        this.characteristicsTableItems = item.characteristics.map((item) => {
          var obj = {
            name: item.name,
            value: item.value
          }
          return obj
        });
      }
    },
    mounted () {
      this.getKayakBySlug()
    }
  }
</script>
<template>
  <div
    class="container"
    v-if="item != null">
    <b-jumbotron
      bg-variant="transparent"
      class="mt-4 mb-1"
      v-if="item != null">
      <p class="title mt-3 mb-4">
        {{ item.name }}
      </p>
      <img
        class="image mt-4"
        :src="imagePath"/>
    </b-jumbotron>
    <b-container>
      <b-row
        v-if="item.availableColors.length > 0">
        <b-col
          md="12"
          class="mx-auto">
          <div
            id="colors-available"
            class="mb-5">
            <div
              class="mb-3 section-title">
              Colori disponibili (RAL CODE)
              <!-- <hr class="my-4"/> -->
            </div>
            <div class="single-color"
              v-for="color in item.availableColors"
              :key="color.ralCode">
              <div
                class="circle-shape"
                :style="{ backgroundColor: '#' + color.hexCode }"/>
              <div class="ral-code">
                {{ color.ralCode }}
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <div
        class="mt-4 mb-3 section-title">
        Descrizione
        <!-- <hr class="my-4"/> -->
      </div>
      <p class="mt-4 mb-5">
        {{ item.description }}
      </p>
      <b-row>
        <b-col
          md="12">
          <div id="pricing-table">
            <b-table
              head-variant="dark"
              class="mt-5 align-left"
              :items="pricingTableItems"
              :fields="pricingTableFields">
              <template #head(name)="data">
                {{ data.label.toUpperCase() }}
              </template>
              <template #cell(name)="data">
                {{ data.value.toUpperCase() }}
              </template>
            </b-table>
          </div>
        </b-col>
        <b-col
          md="6">
          <div id="technical-data-table">
            <b-table
              head-variant="dark"
              class="mt-5 align-left"
              :items="technicalDataTableItems"
              :fields="technicalDataTableFields">
              <template #head(name)="data">
                {{ data.label.toUpperCase() }}
              </template>
              <template #cell(name)="data">
                {{ data.value.toUpperCase() }}
              </template>
            </b-table>
          </div>
        </b-col>
        <b-col
          md="6">
          <div id="characteristics-table">
            <b-table
              head-variant="dark"
              class="mt-5 align-left"
              :items="characteristicsTableItems"
              :fields="characteristicsTableFields">
              <template #head(name)="data">
                {{ data.label.toUpperCase() }}
              </template>
              <template #cell(name)="data">
                {{ data.value.toUpperCase() }}
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <div class="mb-5"></div>
  </div>
  <div
    class="mt-5 mb-5"
    v-else>
    Scheda prodotto non ancora disponibile.
  </div>
</template>
<style scoped>
.title {
  font-weight: 400;
  text-transform: uppercase;
  margin: auto;
  font-size: 4.5rem;
}
.image {
  width: 100%;
}
#colors-available {
  margin: auto;
}
.section-title {
  font-weight: 900;
  text-transform: uppercase;
  margin: auto;
  margin-bottom: 1rem;
  width: fit-content;
  font-size: 1.2rem;
}
.single-color {
  width: fit-content;
  padding: 0.80rem;
  display: inline-block;
}
.ral-code {
  margin-top: 0.50rem;
}
@media(max-width:767px) {
  .title {
  font-size: 2.8rem;
  }
  .section-title {
    font-size: 0.9rem;
  }
}
</style>
